const { createContext } = require("react");

const UpdateHistoryContext = createContext({});

export default UpdateHistoryContext;
